import {Button, Datagrid, DatagridProps, FunctionField, NumberField, Record,} from "react-admin";

import {useOptionsResource} from "../../shared/hooks/useOptionsResource";
import {initField} from "../../shared/utils";
import {Typography} from "@material-ui/core";
import {TariffType} from "../../shared/types";


export const ChargesSummaryDatagrid = (props: DatagridProps & { beforeDate: string | undefined }) => {
  const { data: options } = useOptionsResource("GET");

  return options ? (
    <Datagrid
    >
      <FunctionField
        tabIndex={-1}
        sortable={false}
        label="Cliente"
        render={(tableRecord: Record | undefined) => {
          if (tableRecord) {
            return (
              <Button
                tabIndex={-1}
                //label={`${tableRecord.id}`}
                onClick={() => {
                  let urlParams: any = new URLSearchParams(window.location.search);
                  if (urlParams.has("filter")) {
                    let filter = urlParams.get("filter");
                    let json_filter = JSON.parse(filter)
                    json_filter.client = tableRecord.id
                    let json_string = JSON.stringify(json_filter)
                    json_string = json_string.replace(`"${tableRecord.id}"`, `${tableRecord.id}`)
                    urlParams.set("filter", json_string)
                  }
                  else {
                    let json_string = JSON.stringify({
                      "client": tableRecord.id,
                      "verified": false,
                      "no_invoice": true,
                      "tariff_type": TariffType.SALE,
                      "document_date_before": props.beforeDate,
                      "delivery_last_status": ['D', "SE", "ID", "L", "G", "S", "T"],
                      "page": 2000
                    })
                    json_string = json_string.replace(`"${tableRecord.id}"`, `${tableRecord.id}`)
                    urlParams.set("filter", json_string)
                  }
                  window.open("/charges?" + urlParams.toString())

                }}
              >
                <Typography variant={"body2"}>{`${tableRecord.client__business_name} (${tableRecord.id})`}</Typography>
              </Button>
            );
          }
          return null;
        }}
      />

      <NumberField sortable={false} {...initField("taxable", options)} />

    </Datagrid>
  ) : null;
};
